import React from 'react';
import { StoryblokStory } from 'storyblok-generate-ts';

import { useSelectedLocationStore } from '../../stores/SelectedLocationStore';
import { LocationDetails } from '../LocationDetails/LocationDetails';

import { Accordion } from '@/components/ui/Accordion/Accordion';
import { LocationStoryblok } from '@/types/storyblok/storyblok-types';

import styles from './LocationAccordions.module.scss';

type LocationAccordionsProps = {
    locations: StoryblokStory<LocationStoryblok>[];
};

export const LocationAccordions: React.FC<LocationAccordionsProps> = ({ locations }) => {
    const { selectedLocation, setSelectedLocation } = useSelectedLocationStore();
    return (
        <div className={styles.root}>
            {locations.map(story => (
                <Accordion
                    id={story.uuid}
                    key={story.uuid}
                    title={story.content.name}
                    className={styles.accordion}
                    isOpen={story.uuid === selectedLocation}
                    onClose={() => {
                        if (story.uuid === selectedLocation) {
                            setSelectedLocation(null);
                        }
                    }}
                >
                    <LocationDetails
                        key={story.uuid}
                        location={story}
                        hideCityName
                    />
                </Accordion>
            ))}
        </div>
    );
};
